<template>
  <div class="flex-grow flex mx-correction relative">
    <div
      class="mt-16 lg:mt-24 transition-opacity flex-grow absolute-childeren"
      ref="stack"
    >
      <slot :handleLoad="handleLoad" />
    </div>
  </div>
</template>

<script>
import throttle from "lodash.throttle";
import MagicGrid from "magic-grid";
import { mapState } from "vuex";

export default {
  name: "BlockTileStack",

  props: {
    stack: {
      type: Array,
      default: () => []
    },
    reposition: {
      type: Number,
      default: 0
    }
  },

  computed: {
    ...mapState({
      deviceWidth: state => state.ui.deviceWidth
    })
  },

  watch: {
    stack() {
      this.positionItems();
    },
    deviceWidth() {
      // Rather than using .listen, work with the global event listners
      this.positionItems();
    },
    reposition() {
      this.positionItems();
    }
  },

  mounted() {
    this.initGrid();
  },

  methods: {
    /**
     * The init function
     */
    initGrid() {
      if (this.stack === null) return;
      if (!this._isMounted) return;

      this.magicGrid = new MagicGrid({
        container: this.$refs.stack,
        items: this.stack.length,
        useMin: true, // keep rows more in line
        gutter: 0,
        maxColumns: 6
      });

      this.positionItems();
    },

    /**
     * Throttled load event handler
     */
    handleLoad: throttle(
      function() {
        this.positionItems();
        this.$emit("positionItems");
      },
      150,
      {
        leading: false,
        trailing: true
      }
    ),

    /**
     * Position Items
     */
    async positionItems() {
      if (!this.stack.length) return;

      // Botched way to check initHas been called
      // Bad variable naming
      if (typeof this.magicGrid === "undefined") {
        this.initGrid();
      }

      await this.$nextTick();

      this.magicGrid.size = this.stack.length;
      this.magicGrid.positionItems();
    }
  }
};
</script>

<style scoped>
.absolute-childeren * {
  position: absolute;
}

.mx-correction {
  margin-left: -0.625rem;
  margin-right: -0.625rem;
}
</style>
